import { call } from 'redux-saga/effects';
import { safe } from '@app/react/saga/common/safe';
import {
    fetchKintekiModel,
    fetchEntekiModel,
    fetchMakiwaraModel,
} from '@app/react/common/loadModel';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* loadKintekiModel() {
    const { result: model, error } = yield safe(call(fetchKintekiModel, true));
    if (error !== null) {
        console.error('[saga] error load 3d kinteki model:', error);
        return null;
    }
    console.log('[saga] load 3d kinteki model:', model);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return model;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* loadEntekiModel() {
    const { result: model, error } = yield safe(call(fetchEntekiModel, true));
    if (error !== null) {
        console.error('[saga] error load 3d enteki model:', error);
        return null;
    }
    console.log('[saga] load 3d enteki model:', model);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return model;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* loadMakiwaraModel() {
    const { result: model, error } = yield safe(call(fetchMakiwaraModel, true));
    if (error !== null) {
        console.error('[saga] error load 3d makiwara model:', error);
        return null;
    }
    console.log('[saga] load 3d makiwara model:', model);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return model;
}
